
	if ( ! customElements.get('floating-price-updater') ) {
		customElements.define(
			'floating-price-updater',
			class FloatingPriceUpdater extends HTMLElement {
				constructor() {
					super();
					this.floatingPriceElement = document.getElementById('product-sticky-atc');

					// If the floating price element doesn't exist, don't do anything
					if (!this.floatingPriceElement) return;

					// Find the product form to check visibility
					this.productForm = document.querySelector('.product-form__container');

					// Add event listener to the floating bar button
					const floatingButton = document.querySelector('.product-sticky-atc button');
					if (floatingButton) {
						floatingButton.addEventListener('click', this.handleButtonClick.bind(this));
					}

					// Set up Intersection Observer
					this.setupIntersectionObserver();

				}

				setupIntersectionObserver() {
					// Options for the observer
					const options = {
					  root: null, // Use the viewport as the root
					  rootMargin: '0px', // No margin
					  threshold: 0.1 // Trigger when at least 10% of the target is visible
					};
					
					// Create the observer
					this.observer = new IntersectionObserver((entries, observer) => {
						console.log(entries);
						// We're only observing one element, so we can just use the first entry
						const entry = entries[0];

						// If the product form is not intersecting (not visible)
						if (!entry.isIntersecting) {
							this.floatingPriceElement.classList.add('active');
						} else {
							this.floatingPriceElement.classList.remove('active');
						}
					}, options);
					
					// Start observing the product form
					this.observer.observe(this.productForm);
				}

				// Handle button click to trigger the original submit button
				handleButtonClick(event) {
					event.preventDefault();
					// Find the original submit button
					const submitButton = document.querySelector('#ProductSubmitButton-' + this.dataset.section);
					if (submitButton) {
						// Trigger a click on the original submit button
						submitButton.click();
					}
				}

				variantChangeUnsubscriber = undefined;
				connectedCallback() {
					console.log('Connected callback called');
					// Check if dependencies exist
					if (typeof PUB_SUB_EVENTS === 'undefined') {
						// console.error('PUB_SUB_EVENTS is not defined');
						return;
					}

					if (typeof subscribe !== 'function') {
						// console.error('subscribe function is not defined');
						return;
					}

					this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
						// console.log('variant change');
						// Make sure we're updating the right product section
						const sectionId = this.dataset.section;
						// console.log('Section ID: ' + sectionId );
						if (event.data.sectionId !== sectionId) return;
						// console.log('Getting ready to update' );

						// Update the floating price with the new variant price
						this.updateFloatingPrice(event.data.variant, event.data.html);
					});
				}
		
				disconnectedCallback() {
				if (this.variantChangeUnsubscriber) {
					this.variantChangeUnsubscriber();
				}
				}
		
				updateFloatingPrice(variant, html) {
				if (!variant || !this.floatingPriceElement) return;
				
				// Get the formatted price from the HTML
				const priceContainer = html.getElementById(`price-${this.dataset.section}`);
				if (!priceContainer) return;
				
				const priceElement = priceContainer.querySelector('.price-item--regular');
				if (!priceElement) return;
				
				// Update the floating price
				this.floatingPriceElement.innerHTML = priceElement.innerHTML;
				}
			}
		);
	}
